package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GridProduct(
    @SerialName("product")
    val product: Product?,
    @SerialName("productId")
    val productId: String?,
    @SerialName("__typename")
    val typename: String?
)